module.exports = __webpack_public_path__ + "fonts/adellesans-light-webfont.36115ebd.woff";